export default "__VITE_ASSET__d0684339__"